import React from 'react'
import styled from 'styled-components'

import Modal from 'components/Modal'
import ProductLiteratureGroup from 'pages/shared/ProductLiteratureGroup'
import Spinner from 'components/Spinner'

import useProductLiterature from 'hooks/useProductLiterature'

import { color } from 'styles/colors'
import { NoData } from 'styles/shared'

type Props = {
  closeCallback: () => void
  modelNumber: string
  isDisplayed: boolean
}

const ProductLiteratureSearchModal = ({ closeCallback, modelNumber, isDisplayed }: Props) => {
  const { productLiterature, isProductLiteratureLoaded, serverError } = useProductLiterature(modelNumber)

  return (
    <S.Modal
      closeCallback={closeCallback}
      isDisplayed={isDisplayed}
      title="Product Literature Search"
      variant="lg"
    >
      {modelNumber.length < 4 && (
        <NoData>
          <h1>Unable to search</h1>
          <h2>Model number must be at least 4 characters</h2>
        </NoData>
      )}

      {serverError && (
        <NoData>
          <h1>Unable to search</h1>
          <h2>An error has occurred on the server. Refresh this page and try again.</h2>
        </NoData>
      )}

      {!isProductLiteratureLoaded && modelNumber.length >= 4 && <Spinner variant="page" />}

      {isProductLiteratureLoaded && productLiterature.length === 0 && !serverError && (
        <NoData>
          <h1>No results</h1>
          <h2>Literature for model number "{modelNumber}" cannot be found</h2>
        </NoData>
      )}

      {isProductLiteratureLoaded && productLiterature.length > 0 && !serverError && (
        <>
          <S.ResultsText>Results for {modelNumber}</S.ResultsText>

          {productLiterature.map((group) => (
            <ProductLiteratureGroup page={'deviceDetails'} key={group.literatureType} group={group} />
          ))}
        </>
      )}
    </S.Modal>
  )
}

export default ProductLiteratureSearchModal

const S = {
  Modal: styled(Modal)`
    min-height: 400px;
  `,
  ResultsText: styled.div`
    font-size: 10px;
    font-weight: bold;
    color: ${color('secondaryText')};
    margin-bottom: 3px;
  `
}
